import GalleryCard from "components/our-services/GalleryCard";
import useLang from "hooks/useLang";
import { useEffect } from "react";

const ServicesPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])
  const { lang } = useLang();

  const services = [
    {
      icon: "icon ti-user",
      to: "/services/individual",
      title: lang.services.our_services.service_card_1_title,
      description: lang.services.our_services.service_card_1_description,
    },
    {
      icon: "icon ti-stats-up",
      to: "/services/accounting-compliance",
      title: lang.services.our_services.service_card_2_title,
      description: lang.services.our_services.service_card_2_description,
    },
    {
      icon: "icon ti-ruler-pencil",
      to: "/services/assistance",
      title: lang.services.our_services.service_card_3_title,
      description: lang.services.our_services.service_card_3_description,
    },
    {
      icon: "icon ti-comment-alt",
      to: "/services/advisory",
      title: lang.services.our_services.service_card_4_title,
      description: lang.services.our_services.service_card_4_description,
    },
    {
      icon: "icon ti-layers-alt",
      to: "/services/documentation",
      title: lang.services.our_services.service_card_5_title,
      description: lang.services.our_services.service_card_5_description,
    },
    {
      icon: "icon ti-alert",
      to: "/services/dispute",
      title: lang.services.our_services.service_card_6_title,
      description: lang.services.our_services.service_card_6_description,
    },
    {
      icon: "icon ti-shopping-cart-full",
      to: "/services/diligence",
      title: lang.services.our_services.service_card_7_title,
      description: lang.services.our_services.service_card_7_description,
    },
    {
      icon: "icon ti-stamp",
      to: "/services/registration",
      title: lang.services.our_services.service_card_8_title,
      description: lang.services.our_services.service_card_8_description,
    },
    {
      icon: "icon ti-shield",
      to: "/services/restitution",
      title: lang.services.our_services.service_card_9_title,
      description: lang.services.our_services.service_card_9_description,
    },
    {
      icon: "icon ti-brush",
      to: "/services/removal",
      title: lang.services.our_services.service_card_10_title,
      description: lang.services.our_services.service_card_10_description,
    },
    {
      icon: "icon ti-unlink",
      to: "/services/exempetion",
      title: lang.services.our_services.service_card_11_title,
      description: lang.services.our_services.service_card_11_description,
    },
    {
      icon: "icon ti-money",
      to: "/services/pricing",
      title: lang.services.our_services.service_card_12_title,
      description: lang.services.our_services.service_card_12_description,
    },
  ];
  
  return (
    <div>
      <div class="services-section section-padding">
        <div class="container">
          <div class="sec-title">
            <div class="title">{lang.services.our_services.service_body_title}</div>
            <h2>
              <span>{lang.services.our_services.service_body_title_span}</span> {lang.services.our_services.service_body_title_text}
            </h2>
          </div>
          <div class="inner-container">
            <div class="row g-0">
              {services.map(service => {
                return <GalleryCard
                  icon={service.icon}
                  to={service.to}
                  title={service.title}
                  description={service.description}
                />
              })}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ServicesPage;
